import React, { useEffect, useState, useCallback, useMemo } from "react";
import PropTypes from "prop-types";
import { Link, useHistory, withRouter } from "react-router-dom";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import { withTranslation } from "react-i18next";
import {
	Card,
	CardBody,
	CardHeader,
	Col,
	Container,
	Form,
	FormFeedback,
	Input,
	Label,
	Nav,
	NavItem,
	NavLink,
	Progress,
	Row,
	TabContent,
	TabPane,
} from "reactstrap";
import Select from "react-select";
import * as Yup from "yup";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Flatpickr from "react-flatpickr";
import axiosInstance from "../../../axiosConfig";
import classnames from "classnames";

const LivreurAdd = (props) => {
	// function LivreurAdd(props) {
	document.title = "Ajouter un livreur | Takci - Admin";

	const history = useHistory();
	const [save, setSave] = useState(false);
	const [activeTab, setactiveTab] = useState(1);
	const [progressbarvalue, setprogressbarvalue] = useState(0);
	const [passedSteps, setPassedSteps] = useState([1]);

	function toggleTab(tab, value) {
		if (activeTab !== tab) {
			var modifiedSteps = [...passedSteps, tab];

			if (tab >= 1 && tab <= 4) {
				setactiveTab(tab);
				setPassedSteps(modifiedSteps);
			}
		}
		setprogressbarvalue(value);
	}

	const [classEnginOption, setClassEnginOption] = useState([]);
	const [enginOption, setEnginOption] = useState([]);

	const typeEngin = [
		// { value: "Voiture", label: "Voiture" },
		{ value: "Moto", label: "Moto" },
		// { value: "Tricycle", label: "Tricycle" },
	];

	useEffect(() => {
		const fetchData = async () => {
			try {
				const data = await axiosInstance.get(`/allengin`);

				// console.log("Data: ", data);
				// Filter the options based on the type_engin
				const filteredOptions = data.data.data.filter((option) => {
					return option.designation === "Voiture";
				});

				const result_final = filteredOptions.map((item) => ({
					value: item.id,
					label: item.classe ? item.classe : item.designation,
				}));
				setClassEnginOption(result_final);

				const filteredEnginOptions = data.data.data.filter((option) => {
					return option.designation === "Moto";
				});

				const enginData = filteredEnginOptions.map((item) => ({
					value: item.id,
					label:
						item.designation + " " + (item.classe ? ` (${item.classe})` : ""),
				}));
				setEnginOption(enginData);
				// console.log("result_final: ", result_final);
			} catch (err) {
				console.error(`Erreur de récupération des classes d'engin: `, err);
				toast.error(props.t("Erreur de récupération des classes d'engin"), {
					autoClose: 3000,
				});
			}
		};
		fetchData();
	}, []);

	const [passwordShow, setPasswordShow] = useState(false);

	// Infos Perso
	const [infosPerso, setInfosPerso] = useState({
		first_name: "",
		last_name: "",
		email: "",
		telephone: "",
		ville: "",
		code_parrain: "",
		piece_identite: null,
		date_exp_piece_identite: new Date(),
		photo: null,
		attestation_residence: null,
		droit_taxi: null,
		permis: null,
		date_exp_permis: new Date(),
		password: "",
		type_conducteur: "Livreur",
		cg: true,
		independant: false,
	});

	const [errorsInfosPerso, setErrorsInfosPerso] = useState({});

	const validationInfosPersoShema = Yup.object().shape({
		first_name: Yup.string().required(
			props.t("Veuillez renseigner les prénoms")
		),
		last_name: Yup.string().required(props.t("Veuillez renseigner le nom")),
		email: Yup.string().required(props.t("Veuillez renseigner l'email")),
		telephone: Yup.string().required(
			props.t("Veuillez renseigner le numero de téléphone")
		),
		ville: Yup.string().required(props.t("Veuillez renseigner la ville")),
		password: Yup.string().required(
			props.t("Veuillez renseigner le mot de passe")
		),
		piece_identite: Yup.mixed().required(
			props.t("Veuillez télécharger la pièce d'identité")
		),
		attestation_residence: Yup.mixed().required(
			props.t("Veuillez télécharger l'attestation de résidence")
		),
		photo: Yup.mixed().required(props.t("Veuillez télécharger la photo")),

		droit_taxi: Yup.mixed().required(
			props.t("Veuillez télécharger le droit taxi")
		),
		date_exp_piece_identite: Yup.date()
			.required(
				props.t(
					"Veuillez sélectionner la date d'expiration de la pièce d'identité"
				)
			)
			.min(
				new Date(),
				props.t("La date d'expiration doit être ultérieure à aujourd'hui")
			),
	});

	const handleChangeInfosPerso = (e) => {
		const { name, value } = e.target;
		setInfosPerso({ ...infosPerso, [name]: value });
	};

	const handleFileChangePerso = (e) => {
		const { name } = e.target;
		const file = e.target.files[0];
		setInfosPerso({ ...infosPerso, [name]: file });
	};

	const handleDateChangeInfosPerso = (name, date) => {
		const formattedDate = date.toISOString().split("T")[0];
		setInfosPerso({ ...infosPerso, [name]: formattedDate });
	};

	const validateInfosPersoForm = async () => {
		try {
			await validationInfosPersoShema.validate(infosPerso, {
				abortEarly: false,
			});
			setErrorsInfosPerso({});
			return true;
		} catch (err) {
			const validationErrors = {};
			err.inner.forEach((error) => {
				validationErrors[error.path] = error.message;
			});
			setErrorsInfosPerso(validationErrors);
			return false;
		}
	};

	const handleInfosPersoSubmit = async (e) => {
		e.preventDefault();
		const isValid = await validateInfosPersoForm();
		if (isValid) {
			console.log("Form Values on Submit:", infosPerso);
			setInfosPerso({
				first_name: infosPerso.first_name,
				last_name: infosPerso.last_name,
				email: infosPerso.email,
				telephone: infosPerso.telephone,
				ville: infosPerso.ville,
				type_conducteur: "Livreur",
				code_parrain: infosPerso.code_parrain,
				password: infosPerso.password,
				cg: true,
				independant: false,
				piece_identite: infosPerso.piece_identite,
				date_exp_piece_identite: infosPerso.date_exp_piece_identite,
				photo: infosPerso.photo,
				attestation_residence: infosPerso.attestation_residence,
				droit_taxi: infosPerso.droit_taxi,
				permis: null,
				date_exp_permis: null,
			});

			// Switcher vers la nouvelle étape
			toggleTab(2, 50);
			return true;
		}
		return false;
	};

	// Infos Engin
	const [infosEngin, setInfosEngin] = useState({
		marque: "",
		modele: "",
		class_engin: null,
		immatriculation: "",
		nbr_place: 2,
		assurance: "",
		visite_technique: null,
		photo_engin: "",
		type_engin: null,
		climatisation: false,
		carte_grise: "",
	});

	const [errorsInfosEngin, setErrorsInfosEngin] = useState({});

	const validationInfosEnginShema = Yup.object().shape({
		marque: Yup.string().required(props.t("Veuillez renseigner la marque")),
		modele: Yup.string().required(props.t("Veuillez renseigner le modèle")),
		type_engin: Yup.string().required(
			props.t("Veuillez selectionner le type d'engin")
		),
		immatriculation: Yup.string().required(
			props.t("Veuillez renseigner l'immatriculation")
		),
		nbr_place: Yup.number()
			.required(props.t("Veuillez renseigner le nombre de places"))
			.min(2, props.t("Le nombre de places doit être au moins de 2")),

		assurance: Yup.mixed().required(
			props.t("Veuillez télécharger l'assurance")
		),

		photo_engin: Yup.mixed().required(
			props.t("Veuillez télécharger la photo de l'engin")
		),
		carte_grise: Yup.mixed().required(
			props.t("Veuillez télécharger la carte grise")
		),
	});

	const handleChangeInfosEngin = (e) => {
		const { name, value } = e.target;
		setInfosEngin({ ...infosEngin, [name]: value });
	};

	const handleFileChangeEngin = (e) => {
		const { name } = e.target;
		const file = e.target.files[0];
		setInfosEngin({ ...infosEngin, [name]: file });
	};

	const handleDateChangeInfosEngin = (name, date) => {
		const formattedDate = date.toISOString().split("T")[0];
		setInfosEngin({ ...infosEngin, [name]: formattedDate });
	};

	const validateInfosEnginForm = async () => {
		try {
			await validationInfosEnginShema.validate(infosEngin, {
				abortEarly: false,
			});
			setErrorsInfosEngin({});
			return true;
		} catch (err) {
			const validationErrors = {};
			err.inner.forEach((error) => {
				validationErrors[error.path] = error.message;
			});
			setErrorsInfosEngin(validationErrors);
			return false;
		}
	};

	const handleInfosEnginSubmit = async (e) => {
		e.preventDefault();
		const isValid = await validateInfosEnginForm();
		if (isValid) {
			console.log("Form Values on Submit:", infosEngin);

			if (infosEngin.type_engin !== "Voiture") {
				setInfosEngin({ ...infosEngin, class_engin: "" });
				setInfosEngin({ ...infosEngin, climatisation: false });
			}

			setInfosEngin({
				marque: infosEngin.marque,
				modele: infosEngin.modele,
				class_engin: null,
				immatriculation: infosEngin.immatriculation,
				nbr_place: infosEngin.nbr_place,
				assurance: infosEngin.assurance,
				visite_technique: null,
				photo_engin: infosEngin.photo_engin,
				type_engin: infosEngin.type_engin,
				climatisation: false,
				carte_grise: infosEngin.carte_grise,
			});

			// Switcher vers la nouvelle étape
			toggleTab(3, 100);
			validationGlobal();
			return true;
		}
		return false;
	};

	const validationGlobal = async () => {
		const isValid1 = await validateInfosEnginForm();
		const isValid2 = await validateInfosPersoForm();
		// console.log("isValid1: ", isValid1);
		// console.log("isValid2: ", isValid2);

		if (isValid1 && isValid2) {
			const registerData = new FormData();

			// Add infosPerso fields
			Object.keys(infosPerso).forEach((key) => {
				registerData.append(key, infosPerso[key]);
			});

			// Add infosEngin fields
			Object.keys(infosEngin).forEach((key) => {
				registerData.append(key, infosEngin[key]);
			});

			// You can now send registerData to your server
			console.log([...registerData.entries()]);

			try {
				const data = axiosInstance
					.post(`/admindriverregister/`, registerData)
					.then((response) =>
						// const data = axiosInstance
						//   .post(`/driverregister/`, registerData)
						//   .then((response) =>
						{
							console.log("Reponse sauvegarder avec success: ", response);

							//  validation.resetForm();

							toast.success(props.t("Chauffeur ajouté avec succès"), {
								autoClose: 3000,
							});
							setSave(true);
							//  dispatch(onGetChauffeurs());
							//  handleClick();
						}
					);

				console.log("data: ", data);
			} catch (err) {
				setSave(false);
				toast.error(props.t("Echec de l'ajout de la Chauffeur"), {
					autoClose: 3000,
				});
				console.error(err);
			}
			return true;
		} else {
			toast.error(props.t("Tous les champs ne sont pas remplis"), {
				autoClose: 3000,
			});
			// Switcher vers la nouvelle étape
			toggleTab(1, 0);
		}
	};

	return (
		<React.Fragment>
			<div className='page-content'>
				<Container fluid>
					<BreadCrumb
						title={"Ajouter un livreur"}
						pageTitle='Takci'
						pageTitleLink='/livreur'
					/>

					<Row className='g-2'>
						<Col lg={12}>
							<Card className='progress-nav mb-4'>
								<Progress value={progressbarvalue} style={{ height: "1px" }} />
								<Nav
									className='nav-pills progress-bar-tab custom-nav'
									role='tablist'>
									<NavItem>
										<NavLink
											to='#'
											id='pills-gen-info-tab'
											className={classnames(
												{
													active: activeTab === 1,
													done: activeTab <= 4 && activeTab >= 0,
												},
												"rounded-pill"
											)}
											// onClick={() => {
											//   toggleTab(1, 0);
											// }}
											tag='button'
											disabled>
											<i className='ri-user-line'></i>
										</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											to='#'
											id='pills-gen-info-tab'
											className={classnames(
												{
													active: activeTab === 2,
													done: activeTab <= 4 && activeTab > 1,
												},
												"rounded-pill"
											)}
											// onClick={() => {
											//   toggleTab(2, 50);
											// }}
											disabled
											tag='button'>
											<i className='ri-e-bike-fill'></i>
										</NavLink>
									</NavItem>
									<NavItem>
										<NavLink
											to='#'
											id='pills-gen-info-tab'
											className={classnames(
												{
													active: activeTab === 3,
													done: activeTab <= 4 && activeTab > 2,
												},
												"rounded-pill"
											)}
											// onClick={() => {
											//   toggleTab(3, 100);
											// }}
											disabled
											tag='button'>
											<i className='ri-file-damage-line'></i>
										</NavLink>
									</NavItem>
								</Nav>
							</Card>
						</Col>

						<TabContent activeTab={activeTab}>
							{/* Information personnelles */}
							<TabPane tabId={1}>
								<Col lg={12}>
									<Card>
										<CardHeader className='align-items-center d-flex'>
											<h4 className='card-title mb-0 flex-grow-1'>
												Information Personnelles
											</h4>
										</CardHeader>

										<CardBody>
											<Form onSubmit={handleInfosPersoSubmit}>
												<Row className='g-3'>
													{/* Nom */}
													<Col lg={4}>
														<div>
															<Label htmlFor='last_name' className='form-label'>
																{"Nom"} <span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='last_name'
																id='last_name'
																className='form-control'
																placeholder={"Entrez le nom"}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosPerso}
																value={infosPerso.last_name || ""}
																invalid={errorsInfosPerso.last_name}
															/>
															{errorsInfosPerso.last_name ? (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.last_name}
																</FormFeedback>
															) : null}
														</div>
													</Col>
													{/* Prénoms */}
													<Col lg={4}>
														<div>
															<Label
																htmlFor='first_name'
																className='form-label'>
																{"Prénom"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='first_name'
																id='first_name'
																className='form-control'
																placeholder={"Enter Your First Name"}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosPerso}
																value={infosPerso.first_name || ""}
																invalid={errorsInfosPerso.first_name}
															/>
															{errorsInfosPerso.first_name ? (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.first_name}
																</FormFeedback>
															) : null}
														</div>
													</Col>
													{/* Photo  */}
													<Col lg={4}>
														<div>
															<Label className='form-label' htmlFor='photo'>
																{"Photo"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																type='file'
																accept='image/*'
																className='form-control'
																id='photo'
																name='photo'
																onChange={handleFileChangePerso}
																invalid={errorsInfosPerso.photo}
															/>
															{errorsInfosPerso.photo && (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.photo}
																</FormFeedback>
															)}
															{infosPerso.photo && (
																<center className='mt-2'>
																	<img
																		src={URL.createObjectURL(infosPerso.photo)}
																		width='50px'
																		alt='Photo'
																	/>
																</center>
															)}
														</div>
													</Col>
													{/* Pièce d'identité */}
													<Col lg={4}>
														<div>
															<Label
																className='form-label'
																htmlFor='piece_identite'>
																{"Pièce d'identité"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																type='file'
																accept='image/*'
																className='form-control'
																id='piece_identite'
																name='piece_identite'
																onChange={handleFileChangePerso}
																invalid={errorsInfosPerso.piece_identite}
															/>
															{errorsInfosPerso.piece_identite && (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.piece_identite}
																</FormFeedback>
															)}
															{infosPerso.piece_identite && (
																<center className='mt-2'>
																	<img
																		src={URL.createObjectURL(
																			infosPerso.piece_identite
																		)}
																		width='50px'
																		alt="Pièce d'identité"
																	/>
																</center>
															)}
														</div>
													</Col>

													{/* Date expiration Pièce d'identité */}
													<Col lg={4}>
														<div>
															<Label
																className='form-label'
																htmlFor='date_exp_piece_identite'>
																{"Date d'expiration pièce d'identité"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Flatpickr
																className='form-control'
																id='date_exp_piece_identite'
																name='date_exp_piece_identite'
																options={{
																	dateFormat: "Y-m-d",
																	minDate: "today",
																	onChange: (selectedDates) =>
																		handleDateChangeInfosPerso(
																			"date_exp_piece_identite",
																			selectedDates[0]
																		),
																}}
																value={infosPerso.date_exp_piece_identite}
															/>
															{errorsInfosPerso.date_exp_piece_identite && (
																<div className='text-danger'>
																	{errorsInfosPerso.date_exp_piece_identite}
																</div>
															)}
														</div>
													</Col>

													{/* Email */}
													<Col lg={4}>
														<div>
															<Label htmlFor='email' className='form-label'>
																{"Email"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='email'
																id='email'
																className='form-control'
																placeholder={"Entrez l'email"}
																type='email'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosPerso}
																value={infosPerso.email || ""}
																invalid={errorsInfosPerso.email ? true : false}
															/>
															{errorsInfosPerso.email ? (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.email}
																</FormFeedback>
															) : null}
														</div>
													</Col>
													{/* Telephone */}
													<Col lg={4}>
														<div>
															<Label htmlFor='telephone' className='form-label'>
																{"Numéro de téléphone"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='telephone'
																id='telephone'
																className='form-control'
																placeholder={"Entrez le numéro de téléphone"}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosPerso}
																value={infosPerso.telephone || ""}
																invalid={errorsInfosPerso.telephone}
															/>
															{errorsInfosPerso.telephone ? (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.telephone}
																</FormFeedback>
															) : null}
														</div>
													</Col>
													{/* Ville */}
													<Col lg={4}>
														<div>
															<Label htmlFor='ville' className='form-label'>
																{"Ville de résidence"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='ville'
																id='ville'
																className='form-control'
																placeholder={"Entrez la ville"}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosPerso}
																value={infosPerso.ville || ""}
																invalid={errorsInfosPerso.ville}
															/>
															{errorsInfosPerso.ville ? (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.ville}
																</FormFeedback>
															) : null}
														</div>
													</Col>

													{/* Attestation de résidence */}
													<Col lg={4}>
														<div>
															<Label
																className='form-label'
																htmlFor='attestation_residence'>
																{"Attestation de résidence"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																type='file'
																accept='image/*'
																className='form-control'
																id='attestation_residence'
																name='attestation_residence'
																onChange={handleFileChangePerso}
																invalid={errorsInfosPerso.attestation_residence}
															/>
															{errorsInfosPerso.attestation_residence && (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.attestation_residence}
																</FormFeedback>
															)}
															{infosPerso.attestation_residence && (
																<center className='mt-2'>
																	<img
																		src={URL.createObjectURL(
																			infosPerso.attestation_residence
																		)}
																		width='50px'
																		alt='Attestation de résidence'
																	/>
																</center>
															)}
														</div>
													</Col>

													{/* Droit Taxi */}
													<Col lg={4}>
														<div>
															<Label
																className='form-label'
																htmlFor='droit_taxi'>
																{"Droit Taxi"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																type='file'
																accept='image/*'
																className='form-control'
																id='droit_taxi'
																name='droit_taxi'
																onChange={handleFileChangePerso}
																invalid={errorsInfosPerso.droit_taxi}
															/>
															{errorsInfosPerso.droit_taxi && (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.droit_taxi}
																</FormFeedback>
															)}
															{infosPerso.droit_taxi && (
																<center className='mt-2'>
																	<img
																		src={URL.createObjectURL(
																			infosPerso.droit_taxi
																		)}
																		width='50px'
																		alt='Droit Taxi'
																	/>
																</center>
															)}
														</div>
													</Col>

													{/* Code Parrain */}
													<Col lg={4}>
														<div>
															<Label
																htmlFor='code_parrain'
																className='form-label'>
																{"Code du parain"}
															</Label>
															<Input
																name='code_parrain'
																id='code_parrain'
																className='form-control'
																placeholder={"Entrez le code de votre parain"}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosPerso}
																value={infosPerso.code_parrain || ""}
																invalid={errorsInfosPerso.code_parrain}
															/>
															{errorsInfosPerso.code_parrain ? (
																<FormFeedback type='invalid'>
																	{errorsInfosPerso.code_parrain}
																</FormFeedback>
															) : null}
														</div>
													</Col>
													{/* Password */}
													<Col lg={4}>
														<div>
															<Label htmlFor='password' className='form-label'>
																{"Mot de passe"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<div className='position-relative auth-pass-inputgroup mb-3'>
																<Input
																	name='password'
																	id='password'
																	className='form-control pe-5'
																	placeholder={"Enter Your Password"}
																	type={passwordShow ? "text" : "password"}
																	validate={{
																		required: { value: true },
																	}}
																	onChange={handleChangeInfosPerso}
																	value={infosPerso.password || ""}
																	invalid={errorsInfosPerso.password}
																/>
																{errorsInfosPerso.password ? (
																	<FormFeedback type='invalid'>
																		{errorsInfosPerso.password}
																	</FormFeedback>
																) : null}

																<button
																	onClick={() => setPasswordShow(!passwordShow)}
																	className='btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted'
																	type='button'
																	id='password-addon'>
																	{passwordShow ? (
																		<i className='ri-eye-off-fill align-middle'></i>
																	) : (
																		<i className='ri-eye-fill align-middle'></i>
																	)}
																</button>
															</div>
														</div>
													</Col>

													<Row>
														<Col className='d-flex justify-content-end'>
															<button
																type='submit'
																className='btn'
																style={{
																	background: "#002437",
																	color: "white",
																}}>
																Suivant
															</button>
														</Col>
													</Row>
												</Row>
											</Form>
										</CardBody>
									</Card>
								</Col>
							</TabPane>

							{/* Information sur l'engin */}
							<TabPane tabId={2}>
								<Col lg={12}>
									<Card>
										<CardHeader className='align-items-center d-flex'>
											<h4 className='card-title mb-0 flex-grow-1'>
												Information sur l'engin
											</h4>
										</CardHeader>

										<CardBody>
											<Form onSubmit={handleInfosEnginSubmit}>
												<Row className='g-3'>
													{/* Type engin */}
													<Col lg={4}>
														<Label className='form-label' htmlFor='type_engin'>
															{"Type engin"}{" "}
															<span style={{ color: "red" }}>*</span>
														</Label>

														<Select
															name='type_engin'
															id='type_engin'
															type='type_engin'
															validate={{
																required: { value: true },
															}}
															value={
																enginOption.find(
																(option) =>
																	option.value === infosEngin.type_engin
																) || null
															}
															onChange={(e) => {
																setInfosEngin({
																	...infosEngin,
																	type_engin: e.value,
																});
															}}
															options={enginOption}
															invalid={errorsInfosEngin.type_engin}
														/>
														{errorsInfosEngin.type_engin && (
															<FormFeedback type='invalid'>
																{errorsInfosEngin.type_engin}
															</FormFeedback>
														)}
													</Col>

													{/* Marque */}
													<Col lg={4}>
														<div>
															<Label htmlFor='marque' className='form-label'>
																{"Marque"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='marque'
																id='marque'
																className='form-control'
																placeholder={"Entrez la marque de l'engin"}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosEngin}
																value={infosEngin.marque || ""}
																invalid={errorsInfosEngin.marque}
															/>
															{errorsInfosEngin.marque ? (
																<FormFeedback type='invalid'>
																	{errorsInfosEngin.marque}
																</FormFeedback>
															) : null}
														</div>
													</Col>

													{/* Modele */}
													<Col lg={4}>
														<div>
															<Label htmlFor='modele' className='form-label'>
																{"Modele"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='modele'
																id='modele'
																className='form-control'
																placeholder={"Entrez le modele de l'engin"}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosEngin}
																value={infosEngin.modele || ""}
																invalid={errorsInfosEngin.modele}
															/>
															{errorsInfosEngin.modele ? (
																<FormFeedback type='invalid'>
																	{errorsInfosEngin.modele}
																</FormFeedback>
															) : null}
														</div>
													</Col>

													{/* Immatriculation */}
													<Col lg={4}>
														<div>
															<Label
																htmlFor='immatriculation'
																className='form-label'>
																{"Immatriculation"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='immatriculation'
																id='immatriculation'
																className='form-control'
																placeholder={
																	"Entrez le numéro d'immatriculation de l'engin"
																}
																type='text'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosEngin}
																value={infosEngin.immatriculation || ""}
																invalid={errorsInfosEngin.immatriculation}
															/>
															{errorsInfosEngin.immatriculation ? (
																<FormFeedback type='invalid'>
																	{errorsInfosEngin.immatriculation}
																</FormFeedback>
															) : null}
														</div>
													</Col>

													{/* Nombre de place */}
													<Col lg={4}>
														<div>
															<Label htmlFor='nbr_place' className='form-label'>
																{"Nombre de place"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																name='nbr_place'
																id='nbr_place'
																className='form-control'
																placeholder={"Entrez le nombre de place"}
																type='number'
																validate={{
																	required: { value: true },
																}}
																onChange={handleChangeInfosEngin}
																value={infosEngin.nbr_place}
																invalid={errorsInfosEngin.nbr_place}
															/>
															{errorsInfosEngin.nbr_place ? (
																<FormFeedback type='invalid'>
																	{errorsInfosEngin.nbr_place}
																</FormFeedback>
															) : null}
														</div>
													</Col>

													{/* Assurance */}
													<Col lg={4}>
														<div>
															<Label className='form-label' htmlFor='assurance'>
																{"Assurance"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																type='file'
																accept='image/*'
																className='form-control'
																id='assurance'
																name='assurance'
																onChange={handleFileChangeEngin}
																invalid={errorsInfosEngin.assurance}
															/>
															{errorsInfosEngin.assurance && (
																<FormFeedback type='invalid'>
																	{errorsInfosEngin.assurance}
																</FormFeedback>
															)}
															{infosEngin.assurance && (
																<center className='mt-2'>
																	<img
																		src={URL.createObjectURL(
																			infosEngin.assurance
																		)}
																		width='50px'
																		alt='Assurance'
																	/>
																</center>
															)}
														</div>
													</Col>

													{/* Photo de l'engin */}
													<Col lg={4}>
														<div>
															<Label
																className='form-label'
																htmlFor='photo_engin'>
																{"Photo de l'engin"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																type='file'
																accept='image/*'
																className='form-control'
																id='photo_engin'
																name='photo_engin'
																onChange={handleFileChangeEngin}
																invalid={errorsInfosEngin.photo_engin}
															/>
															{errorsInfosEngin.photo_engin && (
																<FormFeedback type='invalid'>
																	{errorsInfosEngin.photo_engin}
																</FormFeedback>
															)}
															{infosEngin.photo_engin && (
																<center className='mt-2'>
																	<img
																		src={URL.createObjectURL(
																			infosEngin.photo_engin
																		)}
																		width='50px'
																		alt="Photo de l'engin"
																	/>
																</center>
															)}
														</div>
													</Col>

													{/* Carte grise */}
													<Col lg={4}>
														<div>
															<Label
																className='form-label'
																htmlFor='carte_grise'>
																{"Carte grise"}{" "}
																<span style={{ color: "red" }}>*</span>
															</Label>
															<Input
																type='file'
																accept='image/*'
																className='form-control'
																id='carte_grise'
																name='carte_grise'
																onChange={handleFileChangeEngin}
																invalid={errorsInfosEngin.carte_grise}
															/>
															{errorsInfosEngin.carte_grise && (
																<FormFeedback type='invalid'>
																	{errorsInfosEngin.carte_grise}
																</FormFeedback>
															)}
															{infosEngin.carte_grise && (
																<center className='mt-2'>
																	<img
																		src={URL.createObjectURL(
																			infosEngin.carte_grise
																		)}
																		width='50px'
																		alt='Carte grise'
																	/>
																</center>
															)}
														</div>
													</Col>

													<Row className='mt-4'>
														<Col className='d-flex justify-content-between'>
															<button
																type='submit'
																className='btn'
																style={{
																	background: "#BED6E3",
																	color: "#002437",
																	border: " 1px solid #002437",
																}}
																onClick={() => {
																	toggleTab(1, 0);
																}}>
																Retour
															</button>

															<button
																type='submit'
																className='btn'
																style={{
																	background: "#002437",
																	color: "white",
																}}>
																Soumettre
															</button>
														</Col>
													</Row>
												</Row>
											</Form>
										</CardBody>
									</Card>
								</Col>
							</TabPane>

							<TabPane tabId={3}>
								<Col lg={12}>
									<Card>
										<div>
											<div className='text-center'>
												<div className='mb-4'>
													<i
														className='bx bx-file-blank'
														style={{ fontSize: "90px" }}>
														{" "}
													</i>
												</div>
												<h5>Enregistrement en cours...</h5>
												<div>
													{save ? (
														<button
															className='btn'
															style={{
																background: "#BED6E3",
																color: "#002437",
																border: " 1px solid #002437",
															}}
															onClick={() => history.push("/livreur")}>
															Allez aux livreurs
														</button>
													) : (
														<button
															className='btn'
															style={{
																background: "#BED6E3",
																color: "#002437",
																border: " 1px solid #002437",
															}}
															onClick={() => {
																toggleTab(1, 0);
															}}>
															Retour
														</button>
													)}
												</div>
											</div>
										</div>
									</Card>
								</Col>
							</TabPane>
						</TabContent>
					</Row>

					<ToastContainer closeButton={false} />
				</Container>
			</div>
		</React.Fragment>
	);
};

LivreurAdd.propTypes = {
	location: PropTypes.object,
	t: PropTypes.any,
};

export default withRouter(withTranslation()(LivreurAdd));
